const DEFAULT_POPUP_WIDTH = 800;
const DEFAULT_POPUP_HEIGHT = 600;

const showLoginPopup = () => {
  const url = App.order.login_path
    ? App.order.login_path.replace(/returnUrl.*$/, 'returnUrl=/login/go/back')
    : 'about:blank';

  const props = window.WK?.loginProps || {};
  const width = props.windowDimensions?.width || DEFAULT_POPUP_WIDTH;
  const height = props.windowDimensions?.height || DEFAULT_POPUP_HEIGHT;

  window.open(
    url,
    'login',
    `alwaysRaised=1,menubar=0,toolbar=0,location=0,personalbar=0,status=0,width=${width},height=${height}`,
  );
};

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e) => {
    const target = e.target;
    const dataLogin = target.getAttribute('data-login');

    if (dataLogin !== null) {
      e.preventDefault();
      showLoginPopup();
    }
  });

  window.addEventListener('showLogin', () => showLoginPopup());
});

export default showLoginPopup;
